import PropType from 'prop-types';
import { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { routePaths } from 'routes/route-paths';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { BaseTable } from '../../../UI/BaseTable';
import { renderColumns } from './util/render-columns';

export const MachineStatus = ({
  machineOverview,
  pagination,
  onPageChange
}) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.OVERVIEW);
  const history = useHistory();

  const columns = useMemo(() => {
    return renderColumns({ t });
  }, [t]);

  const handlePageChange = useCallback(
    (page) => {
      onPageChange(page);
    },
    [onPageChange]
  );

  const handleOnRow = useCallback(
    (columnData) => {
      return {
        onClick: () => {
          return history.push(
            routePaths.machineDetails.replace(':id', columnData.id)
          );
        }
      };
    },
    [history]
  );

  const tableProps = useMemo(
    () => ({
      columns,
      loading: machineOverview.isLoading,
      dataSource: machineOverview.data,
      rowKey: 'id',
      pagination,
      onPageChange: handlePageChange,
      className: 'table-yellow-header widget-body',
      title: t('overviewStatusTable.title'),
      onRow: handleOnRow
    }),
    [
      columns,
      handleOnRow,
      handlePageChange,
      machineOverview.data,
      machineOverview.isLoading,
      pagination,
      t
    ]
  );

  return (
    <div className="machine-status">
      <BaseTable {...tableProps} />
    </div>
  );
};

MachineStatus.propTypes = {
  machineOverview: PropType.shape().isRequired,
  pagination: PropType.shape().isRequired,
  onPageChange: PropType.func.isRequired
};
